import { Injectable, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { BreakpointObserver } from '@angular/cdk/layout';
import { WINDOW_TOKEN } from './bootstrap.service';
import type { OnDestroy } from '@angular/core';
import type { BreakpointState as CdkBreakpointState } from '@angular/cdk/layout';
import type { Observable } from 'rxjs';

// TODO: look into using something like https://css-tricks.com/making-sass-talk-to-javascript-with-json/

//  (min-width exclusive - max-width inclusive]

export enum Breakpoint {
  SM = 'screen and (max-width: 767px)', // mobile
  GT_SM = 'screen and (min-width: 767px)', // tablet portrait, tablet landscape, desktop
  MD = 'screen and (min-width: 767px) and (max-width: 1023px)', // tablet portrait
  GT_MD = 'screen and (min-width: 1023px)', // tablet landscape, desktop
  LG = 'screen and (min-width: 1023px) and (max-width: 1365px)', // tablet landscape
  GT_LG = 'screen and (min-width: 1365px)', // desktop
  LT_LG = 'screen and (max-width: 1365px)', // mobile, tablet portrait, tablet landscape,
  LT_MD = 'screen and (max-width: 1023px)' // mobile, tablet portrait
}

export class BreakpointState {
  constructor(private state: CdkBreakpointState) {
  }

  get matches(): boolean {
    return this.state.matches; // true if at least one of the breakpoints match
  }

  isBreakpointMatch(breakpoint: Breakpoint): boolean {
    return this.state.breakpoints[breakpoint];
  }
}

@Injectable({ providedIn: 'root' })
export class MediaQueryService implements OnDestroy {

  private readonly touchDevice: boolean = false;

  constructor(@Inject(WINDOW_TOKEN) private browserWindow: Window,
              @Inject(BreakpointObserver) private breakpointObserver: BreakpointObserver,
              @Inject(Platform) private platform: Platform) {
    this.touchDevice = this.detectTouchDevice();
  }

  ngOnDestroy(): void {
    this.breakpointObserver.ngOnDestroy();
  }

  observe(...breakpoint: Array<Breakpoint>): Observable<BreakpointState> {
    return this.breakpointObserver.observe(breakpoint as Array<string>).pipe(
      map((state: CdkBreakpointState): BreakpointState => new BreakpointState(state))
    );
  }

  isTouchDevice(): boolean {
    return this.touchDevice;
  }

  private detectTouchDevice(): boolean {
    return this.platform.isBrowser && (
      this.breakpointObserver.isMatched('(pointer: coarse)') ||
      this.browserWindow['navigator'].maxTouchPoints > 0 ||
      ('ontouchstart' in this.browserWindow)
    );
  }

}
